import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getDoc, updateDoc, doc } from 'firebase/firestore'
import { db } from '../firebase-config/firebase'

const Edit = () => {
  const [apellidos, setApellidos] = useState('');
  const [nombre, setNombre] = useState('');
  const [patologias, setPatologias] = useState('');
  const [cedula, setCedula] = useState(0);
  const [edad, setEdad] = useState('');
  const navigate = useNavigate();
  const { id } = useParams();

  const update = async (e) => {
    e.preventDefault()
    const adulto = doc(db, "adultosm", id)
    const data = {
      apellidos: apellidos,
      nombre: nombre,
      cedula: cedula,
      edad: edad,
      patologias: patologias
    }
    
    await updateDoc(adulto, data)
    navigate(`/home/showAdult/${id}`)
  }

  const getAdultoById = async (id) => {

    const adulto = await getDoc(doc(db, "adultosm", id))

      setApellidos(adulto.data().apellidos)
      setNombre(adulto.data().nombre)
      setCedula(adulto.data().cedula)
      setEdad(adulto.data().edad)
      if (adulto.data().patologias === undefined) {
        setPatologias("Sin Patologias")
      }else {
        setPatologias(adulto.data().patologias)
      }
    }
    

  useEffect(() => {
    getAdultoById(id)
    //eslint-disable-next-line
  }, [])

  return (
    <div className="container">
      <div className='Header'>
        <div className="row"> <h1>Editar Adulto</h1> </div>
        <div className='underlineC'></div>
      </div>
      

      <div className="row">

        <div className="col">

          
          <section className='container my-2 bg-dark w-adapt text-light p-2 rcorners'>
            <form onSubmit={update} className='p-4 row g-2 formShadow'>
              <div className='mb-3'>
                <label className='form-label'>Apellidos</label>
                <input
                  value={apellidos}
                  onChange={(e) => setApellidos(e.target.value)}
                  type="text"
                  className='form-control'

                />


              </div>
              <div className='mb-3'>
                <label className='form-label'>Nombre</label>
                <input
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  type="text"
                  className='form-control'

                />

              </div>
              <div className='mb-3'>
                <label className='form-label'>Cedula</label>
                <input
                  value={cedula}
                  onChange={(e) => setCedula(e.target.value)}
                  type="number"
                  className='form-control'

                />

              </div>
              <div className='mb-3'>
                <label className='form-label'>Fecha de nacimiento</label>
                <input
                  value={edad}
                  onChange={(e) => setEdad(e.target.value)}
                  placeholder="Seleccionar fecha"
                  type="date"
                  className='form-control'

                />
              </div>
              <div className='mb-3'>
                <label className='form-label'>Patologias</label>
                <input
                  value={patologias}
                  onChange={(e) => setPatologias(e.target.value)}
                  type="text"
                  className='form-control'

                />

              </div>
              <button type='submit' className='submit'>Actualizar</button>


            </form>
          </section>


        </div>

      </div>
    </div>
  )
}

export default Edit